export default __webpack_public_path__ + "static/media/edit.8dde8a9e.svg";